(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reiss-hero-carousel"] && !Shopify.designMode) return;
  try {
    
class ReissHeroCarousel {
  constructor(root){
    this.root = root;
    this.track = root.querySelector('[data-rc-track]');
    this.slides = [...root.querySelectorAll('[data-rc-slide]')];
    this.dots = [...root.querySelectorAll('[data-rc-dot]')];
    this.index = 0;
    this.count = this.slides.length;
    this.autoplay = root.dataset.autoplay === 'true' && this.count > 1;
    this.interval = parseInt(root.dataset.interval, 10) || 5000;
    this.pauseHover = root.dataset.pauseHover === 'true';
    this.timer = null;
    if (this.count) this.init();
  }
  init(){
    const rm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    this.normalizeVideos();

    const prev = this.root.querySelector('[data-rc-prev]');
    const next = this.root.querySelector('[data-rc-next]');
    if (prev) prev.addEventListener('click', () => this.go(this.index - 1, true));
    if (next) next.addEventListener('click', () => this.go(this.index + 1, true));
    this.dots.forEach(d => d.addEventListener('click', () => this.go(+d.dataset.rcDot, true)));

    if (this.pauseHover){
      this.root.addEventListener('mouseenter', () => this.stop());
      this.root.addEventListener('mouseleave', () => this.start());
    }
    document.addEventListener('visibilitychange', () => document.hidden ? this.stop() : this.start());

    // Breakpoint değişince görünür videoyu yeniden değerlendir
    this.mql = window.matchMedia('(max-width: 749px)');
    const onMQ = () => this.setActive(this.index);
    if (this.mql.addEventListener) this.mql.addEventListener('change', onMQ);
    else if (this.mql.addListener) this.mql.addListener(onMQ);

    let x0 = null;
    this.track.addEventListener('touchstart', e => { x0 = e.touches[0].clientX; }, {passive:true});
    this.track.addEventListener('touchend', e => {
      if (x0 === null) return;
      const dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) this.go(this.index + (dx < 0 ? 1 : -1), true);
      x0 = null;
    }, {passive:true});

    this.setActive(0);
    if (this.autoplay && !rm) this.start();
  }
  /* video_tag bazen <video>'yu bir sarmalayıcı içine koyar veya inline
     width/height verir. Sarmalayıcıları işaretle, attribute'ları temizle →
     video her zaman bölüm kutusunu (banner kutusunu) doldurur. */
  normalizeVideos(){
    this.root.querySelectorAll('.rc-media video').forEach(v => {
      const media = v.closest('.rc-media');
      if (!media) return;
      let p = v.parentElement;
      while (p && p !== media){
        p.classList.add('rc-vwrap');
        p = p.parentElement;
      }
      v.removeAttribute('width');
      v.removeAttribute('height');
      if (v.style){ v.style.width = ''; v.style.height = ''; }
      if (!v.classList.contains('rc-asset')) v.classList.add('rc-asset');
      v.setAttribute('playsinline', '');
      v.muted = true;
    });
  }
  setActive(i){
    this.slides.forEach((s, n) => {
      const on = n === i;
      s.classList.toggle('is-active', on);
      s.setAttribute('aria-hidden', on ? 'false' : 'true');
      // Sadece aktif slayttaki ve o an GÖRÜNÜR olan videoyu oynat
      s.querySelectorAll('video').forEach(v => {
        const visible = v.offsetParent !== null;
        if (on && visible){ v.play().catch(()=>{}); } else { v.pause(); }
      });
    });
    this.dots.forEach((d, n) => {
      d.classList.toggle('is-active', n === i);
      d.setAttribute('aria-selected', n === i ? 'true' : 'false');
    });
    this.index = i;
  }
  go(i, user){
    if (this.count < 2) return;
    i = (i + this.count) % this.count;
    this.setActive(i);
    if (user) this.restart();
  }
  start(){ if (this.autoplay && !this.timer && this.count > 1){ this.timer = setInterval(() => this.go(this.index + 1), this.interval); } }
  stop(){ if (this.timer){ clearInterval(this.timer); this.timer = null; } }
  restart(){ this.stop(); this.start(); }
}

function rcInitAll(scope){
  (scope || document).querySelectorAll('[data-rc-hero]').forEach(el => {
    if (!el.__rc){ el.__rc = new ReissHeroCarousel(el); }
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => rcInitAll());
else rcInitAll();
document.addEventListener('shopify:section:load', e => rcInitAll(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
